import { render, staticRenderFns } from "./CopyPaper.vue?vue&type=template&id=4be4cec8&scoped=true&"
import script from "./CopyPaper.vue?vue&type=script&lang=js&"
export * from "./CopyPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4cec8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be4cec8')) {
      api.createRecord('4be4cec8', component.options)
    } else {
      api.reload('4be4cec8', component.options)
    }
    module.hot.accept("./CopyPaper.vue?vue&type=template&id=4be4cec8&scoped=true&", function () {
      api.rerender('4be4cec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/components/CopyPaper.vue"
export default component.exports